import React from "react";
import Header from "./Header.js";
import Body from "./Body.js";
import TopPanel from "./TopPanel.js";

function App() {
  return (
    <div>
      <Header />
      <TopPanel />
      <Body />
    </div>
  );
}

export default App;
